import IFilter from './IFilter'
import { BSONTypes, getMongoOperator } from './utils/mongo.utils'

/**
 * This class handle the Exist Filters
 * @author Reynaldo
 * Example
 *  {
        "type": "TYPE",
        "field": "um.id.keyword",
        "value": null | object | int | undefined // BSONTypes type
    }
 **/


export default class TypeFilter extends IFilter {

  /**
   * @param filter {Object}
   **/
  constructor (filter) {
    super()
    const { field, value } = filter
    this.type = 'TYPE'
    this.field = field
    this.value = value
    this.filterObject = filter
  }

  clone () {
    return new TermFilter(this.toQuery())
  }

  toQuery () {
    if (!this.field)
      return this.filterObject
    return {
      type: 'TYPE',
      field: this.field,
      value: this.value
    }
  }

  toMongoQuery () {
    if (!this.field)
      return this.filterObject
    return { [this.field]: { [getMongoOperator(this.type)]: BSONTypes[this.value] || BSONTypes.null } }
  }
}
